import FilterMenu from "./FilterMenu";

const SearchFilter = ({
  filterName,
  fieldName,
  options,
  appliedFilters,
  setAppliedFilters,
  ...props
}) => {
  return (
    <FilterMenu
      filterName={filterName}
      fieldName={fieldName}
      options={options}
      appliedFilters={appliedFilters}
      setAppliedFilters={setAppliedFilters}
      showSearch={true}
      {...props}
    />
  );
};

export default SearchFilter;
